import { TranslateResult } from 'vue-i18n';
import i18n from '../i18n';
import { getPaddedDisplayNumber } from '@/helpers/string';
import {
  LessonItemType,
  Exercise,
  ExerciseType,
  LessonItem,
  Video,
  Article,
} from './undergrad/undegrad-lesson.model';
import { Content, ContentText } from './undergrad/undergrad-content.model';

const icons: Record<string, string> = {
  [LessonItemType.VIDEO]: 'play',
  [LessonItemType.ARTICLE]: 'file',
  [ExerciseType.OBJECTIVE]: 'listCheck',
  [ExerciseType.DISCURSIVE]: 'comment',
  [ExerciseType.OBJECTIVE_TRIVIA]: 'comment',
  [ExerciseType.PRACTICE]: 'practicalExercises',
};

class ItemMenuModel {
  items: LessonItem[];

  constructor(item?: LessonItem) {
    this.items = item ? [item] : [];
  }

  get size(): number {
    return this.items.length;
  }

  get item(): LessonItem | undefined {
    return this.items[0];
  }

  get id(): string | undefined {
    return this.item?.id;
  }

  get label(): TranslateResult | string {
    if (this.item) {
      if (this.item.isExercise()) {
        const exercise = this.item as Exercise;

        if (exercise.isObjective()) return i18n.tc('exercise', 1);
        if (exercise.isDiscursive()) return i18n.t('trivia');
        if (exercise.isPractice()) return i18n.t('practice');
      }
      if (this.item.isArticle()) return this.item.name || i18n.tc('article', 1);
      if (this.item.isVideo()) return this.item.name || i18n.tc('video', 1);
    }

    return '';
  }

  get description(): TranslateResult | string {
    if (this.item) {
      if (this.item.isExercise()) {
        const exercise = this.item as Exercise;

        if (exercise.isDiscursive()) return `1 ${i18n.tc('question', 1).toLocaleLowerCase()}`;

        if (exercise.isPractice()) return `1 ${i18n.tc('question', 1).toLocaleLowerCase()}`;

        if (exercise.isObjective()) {
          return `${this.items.length} ${i18n
            .tc('question', this.items.length)
            .toLocaleLowerCase()}`;
        }
      }

      if (this.item.isArticle()) {
        const wordsPerMinute = 250;
        const article = this.item as Article;

        const totalWords = article.contents.reduce((acc: number, content: Content) => {
          const { body } = content as ContentText;
          if (content && body) {
            return acc + body.split(' ').length;
          }
          return acc;
        }, 0);

        const readingMinutes = totalWords / wordsPerMinute;
        return `${readingMinutes.toFixed()} ${i18n.tc('readingMinutes', readingMinutes)}`;
      }

      if (this.item.isVideo()) {
        const video = this.item as Video;

        if (!video.durationInSeconds) return '';
        const videoMinutes = Math.trunc(video.durationInSeconds / 60);
        const videoSeconds = video.durationInSeconds % 60;
        const videoMinutesFormatted = getPaddedDisplayNumber(videoMinutes);
        const videoSecondsFormatted = getPaddedDisplayNumber(videoSeconds);
        return `${videoMinutesFormatted}:${videoSecondsFormatted}`;
      }
    }

    return '';
  }

  get icon(): string | undefined {
    if (!this.item) return undefined;

    const { lessonItemType: contentType } = this.item;

    if (!this.item.isExercise()) {
      return icons[contentType];
    }

    const exercise = this.item as Exercise;

    return icons[exercise.type];
  }

  addItem(item: LessonItem): void {
    this.items.push(item);
  }

  // get progress(): number {
  //   let progress = 0;
  //   this.listItemList.forEach((listItem: ListItemModel) => {
  //     progress += listItem.progress;
  //   });
  //   return progress / this.listItemList.length;
  // }

  // isCompleted(): Boolean {
  //   return this.progress === 100;
  // }
}

export default ItemMenuModel;
